import React from "react";
import { Calendar, MapPin, Trophy } from "lucide-react";
import anniversaryprofile from "../../assets/celebrations/anniversaryprofile.png";

interface WorkAnniversaryProfileCardProps {
    name: string;
    jobTitle: string;
    location: string;
    celebrationDate: string;
    yearsOfService?: number;
    photoUrl?: string;
}

const WorkAnniversaryProfileCard: React.FC<WorkAnniversaryProfileCardProps> = ({ name, jobTitle, location, celebrationDate, yearsOfService, photoUrl }) => {
    return (
        <div className="w-full h-full">

            {/* Anniversary Badge */}
            <div className="flex justify-center mb-2">
                <div className="bg-yellow-500 text-white px-3 py-1 rounded-full text-sm font-semibold shadow-lg">
                    🏆 Work Anniversary
                </div>
            </div>

            {/* Profile Background */}
            <div className="relative rounded-2xl overflow-hidden mb-4">
                <img
                    src={anniversaryprofile}
                    alt="Work Anniversary Background"
                    className="w-full h-[350px] object-cover rounded-2xl"
                />

                {/* Employee Photo */}
                {photoUrl && (
                    <div className="absolute inset-0 flex items-center justify-center">
                        <img
                            src={photoUrl}
                            alt={name}
                            className="w-48 h-48 rounded-full object-cover border-4 border-white/30 shadow-2xl"
                        />
                    </div>
                )}

            </div>

            <h2 className="text-4xl font-bold text-white">
                {name}
            </h2>

            <p className="text-lg text-gray-300 mt-1">
                {jobTitle}
            </p>

            <div className="flex gap-3 mt-4">
                <div className="flex-1 bg-blue-800/40 rounded-xl p-3 flex items-center gap-2">
                    <MapPin className="w-5 h-5 text-yellow-400" />
                    <span>{location}</span>
                </div>

                <div className="flex-1 bg-blue-800/40 rounded-xl p-3 flex items-center gap-2">
                    <Calendar className="w-5 h-5 text-yellow-400" />
                    <span>{celebrationDate}</span>
                </div>
            </div>

            <div className="bg-blue-800/40 rounded-xl p-4 mt-4 flex items-center gap-3">
                <div
                    className="
                        w-12 h-12
                        rounded-full
                        bg-gradient-to-br
                        from-yellow-500
                        to-yellow-700
                        flex
                        items-center
                        justify-center
                    "
                >
                    <Trophy className="w-6 h-6 text-white" />
                </div>

                <div>
                    <p className="text-gray-400 text-sm">
                        Celebration Type
                    </p>

                    <p className="text-yellow-300 font-semibold text-base">
                        {yearsOfService ? `Celebrating ${yearsOfService} ${yearsOfService === 1 ? "Year" : "Years"} 🎉` : "Work Anniversary 🎉"}
                    </p>
                </div>
            </div>

        </div>
    );
};

export default WorkAnniversaryProfileCard;